module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product3-65e190a5933c6787a568addc6792f3aa.jpg";